import ImageBadge from './ImageBadge';



export default ImageBadge;
